(function() {
    "use strict";

    angular.module("swurveys.maker")
        .controller("optoutController", Handler);

    function Handler($scope, $routeParams, localStoreService) {
        localStoreService.setItem("analyticsOptOut", true);
        $scope.message = "You've been opted out of analytics collection. Thank you!"

    };
}());
